/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function GitMergeIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="git-merge"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M6.5 17L6.5 7" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 4.5L15.5 4.5C16.605 4.5 17.5 5.395 17.5 6.5L17.5 17" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={17.5} cy={19.5} r={2.5} stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={6.5} cy={4.5} r={2.5} stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={6.5} cy={19.5} r={2.5} stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
